<script lang='ts'>
import { reactive, defineComponent, computed } from '@vue/composition-api';
import { useAccountStore, GenerateApiToken, RevokeApiToken } from '@/store/global/account';
import { snackbar } from '@/_core/app-components/use';

interface IProps {
    isOpen: boolean;
}

const ApiToken = defineComponent<IProps>({
    name: 'ApiToken',
    props: { isOpen: Boolean },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props, ctx) {
        const store = useAccountStore();
        const state = reactive({
            isGenerateLoading: false,
            isRevokeLoading: false,
        });

        const apiToken = computed(() => store.state.apiToken);
        const apiTokenGeneratedAt = computed(() => store.state.apiTokenGeneratedAt);

        const learnMoreLink = helpLinks.helpLinkUserApiToken;

        const onGenerate = async () => {
            state.isGenerateLoading = true;

            const res = await store.dispatch(new GenerateApiToken());
            if (res) {
                snackbar.showSuccess('Api token has been generated.');
            }

            state.isGenerateLoading = false;
        };

        const onRevoke = async () => {
            state.isRevokeLoading = true;

            const res = await store.dispatch(new RevokeApiToken());
            if (res) {
                snackbar.showSuccess('Api token has been revoked.');
            }

            state.isRevokeLoading = false;
        };

        const close = () => {
            ctx.emit('close');
        };

        return {
            state,
            apiToken,
            apiTokenGeneratedAt,
            learnMoreLink,

            onGenerate,
            onRevoke,

            close
        };
    },
});

export default ApiToken;
</script>

<template>
  <AppDialog
    title="API token"
    :isOpen="isOpen"
    :width="600"
    @close="close"
  >
    <v-card-text>
      <v-alert
        type="info"
        text
        class="mt-4"
      >
        Your token enables access to your data via the API, and needs to be kept private. 
        <a
          class="ma-0 pa-0"
          :href="learnMoreLink"
          target="_blank"
        >
          Learn more
        </a>
      </v-alert>
      <v-text-field
        label="Api token"
        readonly
        :value="apiToken"
        @focus="$event.target.select()"
      />
    
      <div
        v-if="apiTokenGeneratedAt"
      >
        The API token was generated 
        <timeago
          class="d-inline"
          :auto-update="60"
          :datetime="apiTokenGeneratedAt"
        />
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="primary"
        depressed
        :loading="state.isGenerateLoading"
        @click="onGenerate"
      >
        Generate new token
      </v-btn>
      <v-btn
        color="secondary"
        depressed
        class="ml-4"
        :loading="state.isRevokeLoading"
        @click="onRevoke"
      >
        Revoke token
      </v-btn>
    </v-card-actions>
  </AppDialog>
</template>

<style lang='scss' scoped></style>